import { isEqual } from 'lodash';
import { DeepPartialSkipArrayKey } from 'react-hook-form';
import { defaultSubPremiseDto } from '../search-windows/configuration';
import { invalidUnitStatusSearchFormValues } from './configuration';
import { UnitStatusSearchFormType } from './types';

function omitIgnoredFields(
    formValues: DeepPartialSkipArrayKey<UnitStatusSearchFormType>
): DeepPartialSkipArrayKey<UnitStatusSearchFormType> {
    const locations =
        formValues.locations?.map((location) => ({
            ...location,
            subPremiseDtos:
                location.subPremiseDtos?.filter(
                    (subPremiseDto) => !isEqual(subPremiseDto, defaultSubPremiseDto)
                ) ?? [],
        })) ?? [];
    return {
        ...formValues,
        locations,
        fuzzyMatchingEnabled: undefined,
    };
}

export function isFormValid(formValues: DeepPartialSkipArrayKey<UnitStatusSearchFormType>) {
    return !isEqual(
        omitIgnoredFields(formValues),
        omitIgnoredFields(invalidUnitStatusSearchFormValues)
    );
}
